export default "__VITE_ASSET__dee89633__"